import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { LoggedGuard } from '@core/guards/loggedGuard';
import { environment } from 'src/environments/environment';
import { UserRoleEnum } from './core/enums/user-role.enum';

export const routes: Routes = [
  {
    path: 'error/:code',
    loadComponent: () => import('./pages/error/error.component').then((m) => m.ErrorComponent),
  },

  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.routes').then((c) => c.authroutes),
    data: { hideAppLayout: true },
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('./features/auth/auth-logout/auth-logout.component').then((m) => m.AuthLogoutComponent),
  },

  {
    path: 'succesful-register',
    loadComponent: () =>
      import('./features/auth/auth-succesful-register/auth-succesful-register.component').then(
        (m) => m.AuthSuccesfulRegisterComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/layout/layout-without-menu/layout-without-menu.component').then(
        (m) => m.LayoutWithoutMenuComponent
      ),
    children: [
      {
        path: 'sitemap',
        loadComponent: () => import('./features/sitemap/sitemap.component').then((m) => m.SitemapComponent),
        canActivate: [],
        data: {
          breadcrumb: 'sitemap',
          notLogged: true,
          roles: [],
        },
      },
      {
        path: 'too-many-attemps',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './pages/error/login-errors/too-many-attempts-view/too-many-attempts-view.component'
              ).then((m) => m.TooManyAttemptsViewComponent),
          },
        ],
      },
      {
        path: 'no-access',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/error/login-errors/no-access-view/no-access-view.component').then(
                (m) => m.NoAccessViewComponent
              ),
          },
        ],
      },
      {
        path: 'news',
        data: {
          breadcrumb: 'news',
        },
        children: [
          {
            path: '',
            loadComponent: () => import('./features/news/news.component').then((m) => m.NewsComponent),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: ':id/:breadcrumb',
            loadComponent: () =>
              import('./features/news/news-details/news-details.component').then(
                (m) => m.NewsDetailsComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
        ],
      },
      {
        path: 'contact',
        loadComponent: () => import('./features/contact/contact.component').then((m) => m.ContactComponent),
        canActivate: [],
        data: {
          breadcrumb: 'contact',
          roles: [],
        },
      },
      {
        path: 'info',
        data: {
          breadcrumb: 'info',
        },
        children: [
          {
            path: '',
            loadComponent: () => import('./features/info/info.component').then((m) => m.InfoComponent),
            data: {
              breadcrumb: '',
            },
          },

          {
            path: ':id/:breadcrumb',
            loadComponent: () =>
              import('./features/info/info-details/info-details.component').then(
                (m) => m.InfoDetailsComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
        ],
      },
      {
        path: 'download',
        loadComponent: () =>
          import('./features/download/download.component').then((m) => m.DownloadComponent),
        data: {
          breadcrumb: 'download',
        },
      },
      {
        path: 'system-info',
        loadComponent: () =>
          import('./features/system-information/system-information.component').then(
            (m) => m.SystemInformationComponent
          ),
        data: {
          breadcrumb: 'systemInfo',
        },
      },
      {
        path: 'accessibility-declaration',
        loadComponent: () =>
          import('./features/accessibility-declaration/accessibility-declaration.component').then(
            (m) => m.AccessibilityDeclarationComponent
          ),
        data: {
          breadcrumb: 'accessibilityDeclaration',
        },
      },

      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./features/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
        data: {
          breadcrumb: 'privacyPolicy',
        },
      },
      {
        path: 'training',
        data: {
          breadcrumb: 'training',
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/training/training-with-captcha/training-with-captcha.component').then(
                (m) => m.TrainingWithCaptchaComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: 'workflow',
            loadComponent: () =>
              import('./features/training/training-workflow/training-workflow.component').then(
                (m) => m.TrainingWorkflowComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: 'sent',
            loadComponent: () =>
              import('./features/training/training-sent/training-sent.component').then(
                (m) => m.TrainingSentComponent
              ),
            data: {
              breadcrumb: '',
            },
          },

          {
            path: 'sent-error',
            loadComponent: () =>
              import('./features/training/training-sent/training-sent.component').then(
                (m) => m.TrainingSentComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
        ],
      },
      {
        path: 'contact',
        loadComponent: () => import('./features/contact/contact.component').then((m) => m.ContactComponent),
        data: {
          breadcrumb: 'contact',
        },
      },
    ],
  },
  {
    path: 'waiting-page',
    loadComponent: () =>
      import('./pages/waiting-page/waiting-page.component').then((m) => m.WaitingPageComponent),
  },
  {
    path: 'main',
    loadComponent: () =>
      import('./features/layout/layout-with-menu/layout-with-menu.component').then(
        (m) => m.LayoutWithMenuComponent
      ),
    canActivate: [LoggedGuard],
    data: {
      roles: [UserRoleEnum.Employee],
    },
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [LoggedGuard],
        data: {
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'userprofile',
        loadComponent: () =>
          import('./features/userprofile/userprofile.component').then((m) => m.UserProfileComponent),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'userprofile',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'news',
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'news',
          roles: [UserRoleEnum.Employee],
        },
        children: [
          {
            path: '',
            loadComponent: () => import('./features/news/news.component').then((m) => m.NewsComponent),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: ':id/:breadcrumb',
            loadComponent: () =>
              import('./features/news/news-details/news-details.component').then(
                (m) => m.NewsDetailsComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
        ],
      },
      {
        path: 'announcements',
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'announcements',
          roles: [UserRoleEnum.Employee],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/announcements/announcements.component').then(
                (m) => m.AnnouncementsComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: ':id/:breadcrumb',
            loadComponent: () =>
              import('./features/announcements/announcements-details/announcements-details.component').then(
                (m) => m.AnnouncementsDetailsComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
        ],
      },
      {
        path: 'history',
        loadComponent: () => import('./features/history/history.component').then((m) => m.HistoryComponent),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'history',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'xml-files',
        loadComponent: () =>
          import('./features/xml-files/xml-files.component').then((m) => m.XmlFilesComponent),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'xmlFiles',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'xml-files/submit',
        loadComponent: () =>
          import('./features/xml-files/view/xml-files-main/xml-files-main.component').then(
            (m) => m.XmlFilesMainComponent
          ),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'xmlFiles',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'questionnaires',
        redirectTo: '/error/414',
        pathMatch: 'full',
      },
      {
        path: 'notarial-form',
        loadComponent: () =>
          import('./features/notarial-form/notarial-form.component').then((m) => m.NotarialFormComponent),
        canActivate: [
          LoggedGuard,
          () => (environment.label !== 'UAT' ? true : inject(Router).createUrlTree(['/main/dashboard'])),
        ],
        data: {
          breadcrumb: 'notarialForm',
          roles: [UserRoleEnum.Employee],
        },
        children: [
          {
            path: 'new',
            loadComponent: () =>
              import('@features/notarial-form/steps/new-form/new-form.component').then(
                (m) => m.NewFormComponent
              ),
            canActivate: [LoggedGuard],
            data: {
              breadcrumb: 'newNotarialForm',
              roles: [UserRoleEnum.Employee],
            },
          },
          {
            path: 'start',
            loadComponent: () =>
              import('./features/notarial-form/steps/new-form-start/new-form-start.component').then(
                (m) => m.NewFormStartComponent
              ),
            canActivate: [LoggedGuard],
            data: {
              breadcrumb: 'newNotarialForm',
              roles: [UserRoleEnum.Employee],
            },
          },
          {
            path: 'activity/new',
            loadComponent: () =>
              import(
                './features/notarial-form/steps/notarial-activity-form/notarial-activity-form.component'
              ).then((m) => m.NotarialActivityFormComponent),
            canActivate: [LoggedGuard],
            data: {
              breadcrumb: 'newActivity',
              roles: [UserRoleEnum.Employee],
            },
          },
          {
            path: ':breadcrumb',
            children: [
              {
                path: ':breadcrumb',
                loadComponent: () =>
                  import('./features/notarial-form/steps/form-send/form-send.component').then(
                    (m) => m.FormSendComponent
                  ),
                canActivate: [LoggedGuard],
                data: {
                  roles: [UserRoleEnum.Employee],
                },
              },
            ],
          },
        ],
      },
      {
        path: 'training',
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'training',
          roles: [UserRoleEnum.Employee],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/training/training.component').then((m) => m.TrainingComponent),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: 'workflow',
            loadComponent: () =>
              import('./features/training/training-workflow/training-workflow.component').then(
                (m) => m.TrainingWorkflowComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: 'sent',
            loadComponent: () =>
              import('./features/training/training-sent/training-sent.component').then(
                (m) => m.TrainingSentComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: 'sent-error',
            loadComponent: () =>
              import('./features/training/training-sent/training-sent.component').then(
                (m) => m.TrainingSentComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
        ],
      },
      {
        path: 'download',
        loadComponent: () =>
          import('./features/download/download.component').then((m) => m.DownloadComponent),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'download',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'info',
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'info',
          roles: [UserRoleEnum.Employee],
        },
        children: [
          {
            path: '',
            loadComponent: () => import('./features/info/info.component').then((m) => m.InfoComponent),
            data: {
              breadcrumb: '',
            },
          },
          {
            path: ':id/:breadcrumb',
            loadComponent: () =>
              import('./features/info/info-details/info-details.component').then(
                (m) => m.InfoDetailsComponent
              ),
            data: {
              breadcrumb: '',
            },
          },
        ],
      },
      {
        path: 'contact',
        loadComponent: () => import('./features/contact/contact.component').then((m) => m.ContactComponent),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'contact',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'system-info',
        loadComponent: () =>
          import('./features/system-information/system-information.component').then(
            (m) => m.SystemInformationComponent
          ),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'systemInfo',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'accessibility-declaration',
        loadComponent: () =>
          import('./features/accessibility-declaration/accessibility-declaration.component').then(
            (m) => m.AccessibilityDeclarationComponent
          ),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'systemInfo',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./features/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'privacyPolicy',
          roles: [UserRoleEnum.Employee],
        },
      },
      {
        path: 'sitemap',
        loadComponent: () => import('./features/sitemap/sitemap.component').then((m) => m.SitemapComponent),
        canActivate: [LoggedGuard],
        data: {
          breadcrumb: 'sitemap',
          roles: [UserRoleEnum.Employee],
        },
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./pages/error/error.component').then((m) => m.ErrorComponent),
    data: { errorCode: 404 },
  },
];
